/**
 * Funciones de cálculo específicas para proveedores Lizen
 */

/**
 * Calcula el valor con IVA a partir del valor sin IVA
 * @param {number} valorSinIva - Valor sin IVA
 * @returns {number} Valor con IVA (multiplicado por 1.21)
 */
export const calculateIva = (valorSinIva) => {
  return valorSinIva * 1.21;
};

/**
 * Calcula el valor por kilómetro basado en el valor total y la cantidad de KM
 * @param {number} valorTotal - Valor total (con o sin IVA)
 * @param {number} cantidadKM - Cantidad de kilómetros
 * @returns {number} Valor por kilómetro
 */
export const calculateKM = (valorTotal, cantidadKM) => {
  if (cantidadKM === 0 || cantidadKM === null || cantidadKM === "") {
    return 0;
  }
  return valorTotal / cantidadKM;
};

/**
 * Procesa los datos de un proveedor para calcular valores derivados
 * @param {Object} proveedorData - Datos del proveedor
 * @param {number} indice - Índice del proveedor en el array
 * @returns {Object} Datos procesados del proveedor
 */
export const processProveedorData = (proveedorData, indice) => {
  const { proveedor_sinIva, proveedor_conIva, proveedor_cantKM } = proveedorData;
  
  const valorSinIva = proveedor_sinIva[indice] || 0;
  const valorConIva = proveedor_conIva[indice] || 0;
  const cantidadKM = proveedor_cantKM[indice] || 0;

  const valorKM = valorConIva !== 0 
    ? calculateKM(valorConIva, cantidadKM)
    : calculateKM(valorSinIva, cantidadKM);

  return {
    valorSinIva,
    valorConIva,
    cantidadKM,
    valorKM
  };
};
